export const GET_ALL_COLLECTIONS_START = 'GET_ALL_COLLECTIONS_START';
export const GET_ALL_COLLECTIONS_SUCCESS = 'GET_ALL_COLLECTIONS_SUCCESS';
export const GET_ALL_COLLECTIONS_FAIL = 'GET_ALL_COLLECTIONS_FAIL';

export const GET_USER_COLLECTIONS_START = 'GET_USER_COLLECTIONS_START';
export const GET_USER_COLLECTIONS_SUCCESS = 'GET_USER_COLLECTIONS_SUCCESS';
export const GET_USER_COLLECTIONS_FAIL = 'GET_USER_COLLECTIONS_FAIL';

export const GET_COLLECTION_START = 'GET_COLLECTION_START';
export const GET_COLLECTION_SUCCESS = 'GET_COLLECTION_SUCCESS';
export const GET_COLLECTION_FAIL = 'GET_COLLECTION_FAIL';

export const SAVE_COLLECTION_START = 'SAVE_COLLECTION_START';
export const SAVE_COLLECTION_SUCCESS = 'SAVE_COLLECTION_SUCCESS';
export const SAVE_COLLECTION_FAIL = 'SAVE_COLLECTION_FAIL';

export const UPLOAD_ASSET_START = 'UPLOAD_ASSET_START';
export const UPLOAD_LOGO_SUCCESS = 'UPLOAD_LOGO_SUCCESS';
export const UPLOAD_BANNER_SUCCESS = 'UPLOAD_BANNER_SUCCESS';
export const UPLOAD_FEATURE_SUCCESS = 'UPLOAD_FEATURE_SUCCESS';
export const UPLOAD_ASSET_FAIL = 'UPLOAD_ASSET_FAIL';

export const CHECK_URL_START = 'CHECK_URL_START';
export const CHECK_URL_SUCCESS = 'CHECK_URL_SUCCESS';
export const CHECK_URL_FAIL = 'CHECK_URL_FAIL';

export const DELETE_COLLECTION_START = 'DELETE_COLLECTION_START';
export const DELETE_COLLECTION_SUCCESS = 'DELETE_COLLECTION_SUCCESS';
export const DELETE_COLLECTION_FAIL = 'DELETE_COLLECTION_FAIL';